export enum EventTypes {
  GlobalServiceError = 1,
  BuildNewResultView = 2,
  EditResultView = 3
}
